import type {
  CapabilityCreateApiData,
  CapabilityCreateApiResponses,
  CapabilityDeleteApiData,
  CapabilityDeleteApiResponses,
  CapabilityGetApiData,
  CapabilityGetApiResponses,
  CapabilityHoldersPreviewApiData,
  CapabilityHoldersPreviewApiResponses,
  CapabilityListApiData,
  CapabilityListApiResponses,
  CapabilityPatchApiData,
  CapabilityPatchApiResponses
} from '@navio/nsdk';
import { CapabilityType } from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getCapabilityUrls = {
  getPaginatedCapabilities: dataEndpoint<CapabilityListApiData, CapabilityListApiResponses>({
    // Hide ADAPTER caps from pickers by default (auto-managed by adapter sync).
    // Nested on contributions/workstations they still show in read-only UI.
    // Opt in with includeAdapterCapabilities (and optionally capabilityTypes: [ADAPTER]).
    getUrl: (queryParams) => {
      const includeAdapter =
        queryParams.includeAdapterCapabilities === true ||
        (queryParams.capabilityTypes?.includes(CapabilityType.ADAPTER) ?? false);

      if (includeAdapter) {
        return apiUrl('capabilities/', {
          ...queryParams,
          includeAdapterCapabilities: true
        });
      }

      return apiUrl('capabilities/', {
        ...queryParams,
        excludedCapabilityTypes: [...(queryParams.excludedCapabilityTypes ?? []), CapabilityType.ADAPTER]
      });
    }
  }),
  getCapability: dataEndpoint<CapabilityGetApiData, CapabilityGetApiResponses>({
    getUrl: ({ capabilityId }) => apiUrl(`capabilities/${capabilityId}/`)
  }),
  postCapability: responseEndpoint<CapabilityCreateApiData, CapabilityCreateApiResponses>({
    getUrl: () => apiUrl('capabilities/'),
    getBody: (data) => data
  }),
  patchCapability: responseEndpoint<CapabilityPatchApiData, CapabilityPatchApiResponses>({
    getUrl: ({ capabilityId }) => apiUrl(`capabilities/${capabilityId}/`),
    getBody: (data) => data
  }),
  deleteCapability: dataEndpoint<CapabilityDeleteApiData, CapabilityDeleteApiResponses>({
    getUrl: ({ capabilityId }) => apiUrl(`capabilities/${capabilityId}/`)
  }),
  getCapabilityHoldersPreview: dataEndpoint<CapabilityHoldersPreviewApiData, CapabilityHoldersPreviewApiResponses>({
    getUrl: (queryParams) => apiUrl('capabilities/holders-preview/', queryParams)
  })
};
